import { Store } from 'vuex'
import Const from "./const.js";
import Search from "./search.js";
import Register from "./register.js";
import Detail from "./detail.js";
import Verify from './verify.js';

export const store = new Store({
    state: {
        const: Const,
        search: Search,
        register: Register,
        detail: Detail,
        verify: Verify,
    },
    mutations: {
        setItemData: function(state, newValue) {
            var dataParam = newValue.id.split('_');
            var key = dataParam[1];
            switch (dataParam[0]) {
                case 'name':
                    state.register.form.price_images[key].name = newValue.value;
                    break;
                case 'price':
                    state.register.form.price_images[key].price = newValue.value;
                    break;
                case 'description':
                    state.register.form.price_images[key].description = newValue.value;
                    break;
                case 'stock-false':
                case 'stock-true':
                    state.register.form.price_images[key].stock = newValue.value;
                    break;
            }
        },
    },
    actions: {
        getItemData: function({ commit }, newValue) {
            commit('setItemData', newValue);
        },
    }
})
